import {Component} from "@angular/core";
import {DiscountSearchModel} from "../discount-search.model";
import {DiscountEntityModel} from "../discount-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-discount-search-page",
    templateUrl: "./discount-search-page.component.html",
    providers: [provideSearchModel(DiscountSearchModel), provideEntityModel(DiscountEntityModel)]
})
export class DiscountSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
